import api from './api';

export const getUsers = () => api.get('/users');
export const getPermissionRegistry = () => api.get('/users/permissions/registry');
export const createUser = (data) => api.post('/users', data);
export const updateUser = (id, data) => api.put(`/users/${id}`, data);
export const deleteUser = (id) => api.delete(`/users/${id}`);
